import { getUserWorkingHours } from 'owa-session-store';
import { TimeConstants } from 'owa-datetime-utils';
import type { IWorkDay, ITimeSlot } from '../components/SchedulingHours';

export default (): IWorkDay[] => {
    const workingHours = getUserWorkingHours();
    const workingDayTimeSlot: ITimeSlot = {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (11,9): Type 'RecursiveReadOnly<number | undefined>' is not assignable to type 'number'.
        // @ts-expect-error
        startMinutes: workingHours.WorkHoursStartTimeInMinutes,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (15,9): Type 'RecursiveReadOnly<number | undefined>' is not assignable to type 'number'.
        // @ts-expect-error
        endMinutes: workingHours.WorkHoursEndTimeInMinutes,
    };

    return TimeConstants.AllDaysOfWeek.map(day => {
        const dayIndex = Number(day);
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS7034 (23,13): Variable 'dayTimeSlots' implicitly has type 'any[]' in some locations where its type cannot be determined.
        // @ts-expect-error
        let dayTimeSlots = [];

        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (28,29): Object is possibly 'undefined'.
        // @ts-expect-error
        const isWorkingDay = (workingHours.WorkDays & (1 << dayIndex)) != 0;
        if (isWorkingDay) {
            dayTimeSlots = [workingDayTimeSlot];
        }

        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS7005 (36,46): Variable 'dayTimeSlots' implicitly has an 'any[]' type.
        // @ts-expect-error
        return { index: dayIndex, timeSlots: dayTimeSlots } as IWorkDay;
    });
};
